
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { QuestionnaireData } from '@/types/category';
import { bodyParts } from '.';

interface MassageInputsProps {
  formData: QuestionnaireData;
  setFormData: (data: QuestionnaireData) => void;
  categoryId: string;
}

const MassageInputs: React.FC<MassageInputsProps> = ({ formData, setFormData, categoryId }) => {
  const handleBodyPartToggle = (bodyPart: string) => {
    setFormData({
      ...formData,
      targetBodyParts: formData.targetBodyParts?.includes(bodyPart)
        ? formData.targetBodyParts.filter(part => part !== bodyPart)
        : [...(formData.targetBodyParts || []), bodyPart]
    });
  };

  if (categoryId !== 'massage') return null;

  return (
    <>
      {/* Massage Type Input */}
      <div>
        <Label htmlFor="massageType" className="text-base font-medium mb-3 block">
          What type of massage do you prefer? (Optional)
        </Label>
        <Input
          id="massageType"
          placeholder="e.g., Swedish, Deep tissue, Hot stone, Thai, Shiatsu, or leave empty"
          value={formData.massageType || ''}
          onChange={(e) => setFormData({ ...formData, massageType: e.target.value })}
        />
        <p className="text-sm text-muted-foreground mt-1">
          You can specify your preferred massage style or leave this empty for general guidance
        </p>
      </div>

      {/* Target Body Parts */}
      <div>
        <Label className="text-base font-medium mb-3 block">
          Which areas would you like to focus on? (Select all that apply)
        </Label>
        <div className="grid grid-cols-2 gap-2">
          {bodyParts.map((bodyPart) => (
            <div 
              key={bodyPart}
              onClick={() => handleBodyPartToggle(bodyPart)}
              className={`p-3 rounded-lg border cursor-pointer transition-all text-sm ${
                formData.targetBodyParts?.includes(bodyPart)
                  ? 'border-primary bg-primary/10 text-primary-foreground' 
                  : 'border-border hover:border-primary/50 hover:bg-accent'
              }`}
            >
              {bodyPart}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MassageInputs;
